//https://github.com/yeasir01/bpac-js
import * as bpac from "bpac-js";

/* eslint-disable */
export default {
  async printMaterialItemLabels(printLabel) {
    if(printLabel.type == "bpac-js") {
        await this.printBpacJsLabel(printLabel);
    } else {
      throw new Error(`Unsupported print label type: ${printLabel.type}`);
    }
  },

  async printBpacJsLabel(printLabel) {
    console.log("Printing Brother label using bpac-js...");
    console.log("printerParams", printLabel.printerParams);
    console.log("data", printLabel.data);

    const label = new bpac.BrotherSDK(printLabel.printerParams);

    const printOptions = {
        copies: 1
    };

    try {
      await label.print(printLabel.data, printOptions);
    } catch (err) {
      throw new Error(err);
    }

    /*
    if(bpac.IsExtensionInstalled() == false)
      throw new Error("Brother Print Extension is not installed, see: https://github.com/yeasir01/bpac-js/tree/main."); 
    
    const doc = new bpac.Document();
    if (!doc.Open(printLabel.printerParams.templatePath)) 
      throw new Error(`Failed to open Brother label template: '${printLabel.printerParams.templatePath}'`);

    doc.GetObject("description").Text = printLabel.description;
    doc.GetObject("material").Text = printLabel.material;
    doc.GetObject("refId").Text = printLabel.refId;
    doc.GetObject("dateTime").Text = new Date().toLocaleString();

    doc.StartPrint("MaterialLabel", 0);
    doc.PrintOut(1, 0);
    doc.EndPrint();
    doc.Close();*/
  },
}